import restaurantInstance from '../instance'

const fetchWaiterCalls = () => {
  return restaurantInstance.get('/tables/waiterCalls')
}

export default fetchWaiterCalls